import React from 'react';

export default function PrivacyPage() {
  return (
    <main className="privacy-page">
      <section className="privacy-card">
        <h1>Política de Privacidade e Termos LGPD</h1>
        <p>
          A Festify coleta dados pessoais dos convidados apenas para gestão de convites e confirmação de presença.
        </p>

        <h2>1. Dados coletados</h2>
        <p>Nome, email, WhatsApp (opcional), status de confirmação, acompanhantes e restrições alimentares.</p>

        <h2>2. Finalidade</h2>
        <p>Organizar o evento, enviar lembretes e melhorar a experiência de confirmação.</p>

        <h2>3. Base legal</h2>
        <p>Consentimento explícito do titular no momento do envio do RSVP, conforme LGPD.</p>

        <h2>4. Compartilhamento</h2>
        <p>
          Os dados podem ser processados por fornecedores de infraestrutura e comunicação, como Supabase, Resend e Twilio,
          sempre dentro da finalidade do evento.
        </p>

        <h2>5. Retenção e exclusão</h2>
        <p>Os dados podem ser removidos mediante solicitação ao organizador do evento.</p>

        <h2>6. Direitos do titular</h2>
        <p>Você pode solicitar acesso, correção, anonimização ou exclusão dos seus dados.</p>
      </section>
    </main>
  );
}
